var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "#5990E4",
    stroke: "#5990E4",
    strokeWidth: 2,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8685 7.88672L16.7185 12.4992L22.8685 17.1117L22.8685 7.88672Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8735 6.34961L4.72598 6.34961C3.70702 6.34961 2.88098 7.13631 2.88098 8.10675L2.88098 16.8925C2.88098 17.8629 3.70702 18.6496 4.72598 18.6496L14.8735 18.6496C15.8924 18.6496 16.7185 17.8629 16.7185 16.8925L16.7185 8.10675C16.7185 7.13631 15.8924 6.34961 14.8735 6.34961Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.88d714870a13a9a32c08b4586cbc3ccc.svg";
export { ForwardRef as ReactComponent };